<div class="notification" *ngFor="let notification of notifications">{{ notification['text'] }}</div>